module.exports = __webpack_public_path__ + "static/media/18.5f5350f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/18.png
// module id = 935
// module chunks = 0